import { PrintJobStatus } from '@/types'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import {
Tooltip,
TooltipContent,
TooltipProvider,
TooltipTrigger,
} from '@/components/ui/tooltip'

export function JobStatusBadge({
  status,
  className,
  dotOnly = false,
}: {
  status: PrintJobStatus
  className?: string
  dotOnly?: boolean
}) {
  const config = {
    [PrintJobStatus.PENDING]: {
      bg: 'bg-yellow-500/10 text-yellow-700 border-yellow-500/20',
      dot: 'bg-yellow-600',
      label: 'Pending',
    },
    [PrintJobStatus.SENT]: {
      bg: 'bg-blue-500/10 text-blue-700 border-blue-500/20',
      dot: 'bg-blue-600',
      label: 'Sent',
    },
    [PrintJobStatus.PRINTED]: {
      bg: 'bg-green-500/10 text-green-700 border-green-500/20',
      dot: 'bg-green-600',
      label: 'Printed',
    },
    [PrintJobStatus.FAILED]: {
      bg: 'bg-red-500/10 text-red-700 border-red-500/20',
      dot: 'bg-red-600',
      label: 'Failed',
    },
    [PrintJobStatus.CANCELLED]: {
      bg: 'bg-gray-500/10 text-gray-500 border-gray-500/20',
      dot: 'bg-gray-400',
      label: 'Cancelled',
    },
  }

  const { bg, dot, label } = config[status]

  if (dotOnly) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <span 
              className={cn('w-2 h-2 rounded-full shrink-0 cursor-help', dot, className)} 
            />
          </TooltipTrigger>
          <TooltipContent side="top" align="center">
            {label}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    )
  }

  return (
    <Badge
      variant="outline"
      className={cn('font-medium text-xs whitespace-nowrap px-2 py-0.5', bg, className)}
    >
      <span className={cn('w-1.5 h-1.5 rounded-full mr-1.5 shrink-0', dot)} />
      {label}
    </Badge>
  )
}
